export default __webpack_public_path__ + "static/arthur-36f5e94785e01f4053dac03a4f16d9d8.jpg";